import { Link as RouterLink } from 'react-router-dom';
import { Link, Stack, Typography } from '@mui/material';

import RegisterForm from '../../sections/auth/RegisterForm';

export default function RegisterPage() {
  return (
    <Stack spacing={3}>
      <Stack spacing={1} sx={{ textAlign: 'center' }}>
        <Typography variant="h4">Crear cuenta</Typography>
        <Typography variant="body2" color="text.secondary">
          Regístrate para cotizar, comprar y dar seguimiento a tus órdenes
        </Typography>
      </Stack>

      <RegisterForm />

      <Typography variant="body2" sx={{ textAlign: 'center' }}>
        ¿Ya tienes una cuenta?{' '}
        <Link component={RouterLink} to="/login">
          Inicia sesión
        </Link>
      </Typography>
    </Stack>
  );
}
